import { CENTRA_MARKET_CODE, CentraMarketCode } from "@/data/supported-markets"

export type CountryToMarketMap = Map<string, string>

const countryToMarketMap: CountryToMarketMap = new Map<string, CentraMarketCode>([
    ["Austria", CENTRA_MARKET_CODE.Eu],
    ["Belgium", CENTRA_MARKET_CODE.Eu],
    ["Bulgaria", CENTRA_MARKET_CODE.Eu],
    ["Croatia", CENTRA_MARKET_CODE.Eu],
    ["Cyprus", CENTRA_MARKET_CODE.Eu],
    ["Czech republic", CENTRA_MARKET_CODE.Eu],
    ["Denmark", CENTRA_MARKET_CODE.Eu],
    ["Estonia", CENTRA_MARKET_CODE.Eu],
    ["Finland", CENTRA_MARKET_CODE.Eu],
    ["France", CENTRA_MARKET_CODE.Eu],
    ["Germany", CENTRA_MARKET_CODE.Eu],
    ["Greece", CENTRA_MARKET_CODE.Eu],
    ["Hungary", CENTRA_MARKET_CODE.Eu],
    ["Ireland", CENTRA_MARKET_CODE.Eu],
    ["Italy", CENTRA_MARKET_CODE.Eu],
    ["Latvia", CENTRA_MARKET_CODE.Eu],
    ["Lithuania", CENTRA_MARKET_CODE.Eu],
    ["Luxemburg", CENTRA_MARKET_CODE.Eu],
    ["Malta", CENTRA_MARKET_CODE.Eu],
    ["Netherlands", CENTRA_MARKET_CODE.Eu],
    ["Norway", CENTRA_MARKET_CODE.Eu],
    ["Poland", CENTRA_MARKET_CODE.Eu],
    ["Portugal", CENTRA_MARKET_CODE.Eu],
    ["Romania", CENTRA_MARKET_CODE.Eu],
    ["Slovakia", CENTRA_MARKET_CODE.Eu],
    ["Slovenia", CENTRA_MARKET_CODE.Eu],
    ["Spain", CENTRA_MARKET_CODE.Eu],
    ["Sweden", CENTRA_MARKET_CODE.Eu],
    ["Switzerland", CENTRA_MARKET_CODE.Eu],
    ["United kingdom", CENTRA_MARKET_CODE.Eu],
    ["Canada", CENTRA_MARKET_CODE.Na],
    ["United states", CENTRA_MARKET_CODE.Na],
    ["Australia", CENTRA_MARKET_CODE.Apac],
    ["New zealand", CENTRA_MARKET_CODE.Apac],
    ["Japan", CENTRA_MARKET_CODE.Jp]
])
export default countryToMarketMap
